import { createSelector } from 'reselect';

/**
 * Direct selector to the widgets state domain
 */
const selectWidgetsDomain = () => (state) => state.get('widgets');

/**
 * Other specific selectors
 */

/**
 * Default selector used by Widgets
 */

const selectWidgets = () =>
  createSelector(selectWidgetsDomain(), (substate) => substate.toJS());

const selectWidget = (widgetId) =>
  createSelector(selectWidgetsDomain(), (substate) =>
    substate.getIn([widgetId, 'widget'])
  );

const selectDefinition = (widgetId) =>
  createSelector(selectWidgetsDomain(), (substate) =>
    substate.getIn([widgetId, 'definition'])
  );

const selectError = (widgetId) =>
  createSelector(selectWidgetsDomain(), (substate) =>
    substate.getIn([widgetId, 'error'])
  );

const selectLoading = (widgetId) =>
  createSelector(selectWidgetsDomain(), (substate) =>
    substate.getIn([widgetId, 'loading'])
  );

export default selectWidgets;
export {
  selectWidgetsDomain,
  selectWidget,
  selectDefinition,
  selectError,
  selectLoading,
};
